import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import TicketsList from './TicketsList/TicketsList';

const Tickets = ({ match }) => {
    return (
        <div className="Tickets">
            <ContainerWrapper container="tickets">
                <Route exact path={match.path} component={TicketsList} />
            </ContainerWrapper>
        </div>
    );
}

export default Tickets;
